/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import EditLabels from 'material/embeds/editlabels/editlabels_container';
import {
    Page,
    Content,
    Title,
    Icon,
    StandardPagination,
    LoadState,
    EmptyState,
    debounce,
    Loader,
    PopupMessage,
} from '@insticator/insticator-ui'; // iui-material
import { generateDefaultStartDate, generateDefaultEndDate } from 'utils/datePickerDefaultDates';
import EditEmbedName from 'pages/dashboard/embeds/management/editembedname/editembedname_container';
import ControlBar from 'material/embeds/controlbar/controlbar';
import EmbedCard from 'material/embeds/embedcard/embedcard';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/library/library_styles';



/* ========== ~~~~~~~~~~ EMBED LIBRARY ~~~~~~~~~~ ========== */
class LibraryPage extends Component {
    constructor(props) {
        super(props);
        this.itemsPerPage = 20;
        this.items = this.getItemsForDisplay(this.props.clientEmbeds);
        this.state = {
            filteredItems: this.sortByNameAlphabetically(this.items), // set to clientEmbeds from BE initially (before search and sort)
            disableEmbedCards: false,

            keyword: '',
            active: true,
            dateRange: {
                from: null,//null,
                to: null, //null,
            },
            contentTypes: ['QUIZ', 'POLL', 'STORY'], // ["QUIZ", "STORY"],
            embedState: [], //true/false,
            labels: []
        };
    }

    componentDidMount() {
        this.props.resetEmbedAndContentState();
        this.applyFilters();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.clientEmbeds !== this.props.clientEmbeds) {
            this.items = this.getItemsForDisplay(this.props.clientEmbeds);
            const filtered = this.sortByNameAlphabetically(this.items);
            this.setState({ filteredItems: filtered });
        }
    }

    applyFilters = (page=1) => {
        this.props.getClientEmbedsData(this.props.accountUUID, this.transpileFilters(this.state, page));
    };

    transpileFilters = (state, page) => ({
        active: state.active,
        embedState: state.embedState.length !== 1 ? null : (!!state.embedState[0] ? 'online' : 'offline'),
        contentTypes: !state.contentTypes.length ? ['QUIZ', 'POLL', 'STORY'] : state.contentTypes,
        lastModifiedStartDate: state.dateRange.from,
        lastModifiedEndDate: state.dateRange.to,
        labelUUIDs: state.labels,
        keyword: !!state.keyword ? state.keyword : null,
        page
    });

    handleSearch = debounce(typedText => this.setState({ keyword: typedText }, this.applyFilters), 400);

    getItemsForDisplay = items => this.props.mockupGenerator && this.props.siteUUID ?
            items.filter(embed => embed.siteUUID === this.props.siteUUID) : Object.assign([], items);

    sortByNameAlphabetically = (embeds) => {
        return embeds.sort(function(a, b) {
            let textA = a.embedName.toUpperCase();
            let textB = b.embedName.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
    };

    editEmbed = (embedUUID) => {
        this.props.editEmbed(embedUUID);
        if(!this.state.disableEmbedCards) this.setState({ disableEmbedCards: true })
    };

    viewAnalytics = (embedUUID) => {
        let embedName = this.getEmbedName(embedUUID);
        this.props.viewAnalytics(embedUUID,null, embedName);
        if(!this.state.disableEmbedCards) this.setState({ disableEmbedCards: true })
    };
    getEmbedName = (embedUUID) => {
        let name = '';
        this.state.filteredItems.forEach(embed => {
            if(embed.embedUUID === embedUUID){
                name = embed.embedName
            }
        });
        return name;
    };

    viewEmails = (embedUUID, embedName) => {
        this.props.viewEmails(embedUUID, embedName);
        if(!this.state.disableEmbedCards) this.setState({ disableEmbedCards: true })
    };

    deleteEmbed = (embedUUID) => {
        this.props.displayModal(false);
        this.props.deleteEmbed(embedUUID, this.props.accountUUID, this.resetDisableEmbedCards);
        if(!this.state.disableEmbedCards) this.setState({ disableEmbedCards: true })
    };

    resetDisableEmbedCards = () => {
        this.setState({ disableEmbedCards: false });
        this.applyFilters();
    };

    archiveEmbed = (embedUUID, embedName) =>
        this.props.displayModal(true,<PopupMessage
            type={'verify'}
            title={`Archive Confirmation`}
            body={<p><span>Are you sure you want to archive <strong>{embedName}</strong>? </span></p>}
            buttonPrimary={{ text: 'Archive', variant: 'delete', action: () => this.props.archiveEmbed(embedUUID, embedName) || this.props.displayModal(false)}}
            buttonSecondary={{ text: 'Cancel', variant: 'system', action: () => this.props.displayModal(false)}}
        />);


    unarchiveEmbed = (embedUUID, embedName) =>
        this.props.displayModal(true, <PopupMessage
            type={'verify'}
            title={`Unarchive Confirmation`}
            body={<p><span>Are you sure you want to unarchive <strong>{embedName}</strong>? </span></p>}
            buttonPrimary={{ text: 'Unarchive', variant: 'action', action: () => this.props.unarchiveEmbed(embedUUID, embedName) || this.props.displayModal(false)}}
            buttonSecondary={{ text: 'Cancel', variant: 'system', action: () => this.props.displayModal(false)}}
        />);

    editLabels = (embedUUID) => this.props.displayModal(true, <EditLabels embedUUID={embedUUID}/>)

    renderLabelsInCard = labelUUIDs => labelUUIDs.map(UUID => this.props.labels[UUID]);

    _renderEmbeds() {
        //This is here for testing and working onn labels
        // let labels = ['hello', 'new', 'labellslssl', 'more', 'label', 'hello', 'new','hello', 'new', 'labellslssl', 'more', 'label','hello', 'new','hello', 'new', 'labellslssl', 'more', 'label', 'hello', 'new','hello', 'new', 'labellslssl', 'more', 'label','hello', 'new', 'labellslssl', 'more', 'label', 'hello', 'new','hello', 'new', 'labellslssl', 'more', 'label','hello', 'new', 'labellslssl', 'more', 'label', 'hello', 'new','hello', 'new', 'labellslssl', 'more', 'label','hello', 'new', 'labellslssl', 'more', 'label','hello', 'new', 'labellslssl', 'more', 'label', 'labellslssl', 'more', 'label', 'labellslssl', 'more', 'label', 'hello', 'new', 'labellslssl', 'more', 'label', 'hello', 'new', 'labellslssl', 'more', 'label'];
        return this.state.filteredItems.map(embed =>
            <EmbedCard key={embed.embedUUID}
                       embedUUID={embed.embedUUID}
                       status={embed.embedState === 'online'}
                       name={embed.embedName}
                       mocked={this.props.mocked}
                       mockupGenerator={this.props.mockupGenerator}
                       site={this.props.clientSites[embed.siteUUID]}
                       posterImage={embed.posterImage}
                       activeContents={embed.liveContentTypes}
                       addOns={embed.addOns}
                       labels={this.renderLabelsInCard(embed.labelUUIDs)}
                       // labels={labels}
                       archiveEmbed={this.archiveEmbed}
                       unarchiveEmbed={this.unarchiveEmbed}
                       archiving={this.props.archiving === embed.embedUUID}
                       archived={this.props.toggledArchive.includes(embed.embedUUID) ? this.state.active : !this.state.active}
                       editLabels={() => this.editLabels(embed.embedUUID)}
                       editPermitted={this.props.editPermitted}
                       editEmbed={this.editEmbed}
                       viewAnalytics={this.viewAnalytics}
                       viewEmails={this.viewEmails}
                       deleteEmbed={this.deleteEmbed}
                       disableEmbedCards={this.state.disableEmbedCards}/>);
    }

    _renderCreateEmbedCard() {
        return (<div className={`newembed disabled-${this.state.disableEmbedCards || !this.props.isDataReceived || this.props.fetchingEmbedNames}`} onClick={()=>this.props.getEmbedNames(this.props.accountUUID, this.createNewEmbed)}>
                                                       <Icon name={`plus-circle`} />
                                                       <div className={`text`}>Create a new Embed!</div>
                                                   </div>)
    }

    createNewEmbed = () => {
        this.props.displayModal(true, <EditEmbedName createEmbed={true} updateEmbed={false} />)
    };

    _renderLoadScreen = () => (<Content>
                                    <LoadState
                                        graphicName={`embed`}
                                        graphicText={`Sample Embed Question`}
                                        bodycopy={`We're fetching your Embeds.`}
                                    />
                                </Content>);

    _renderEmptyState = () => (<Content>
                                    <EmptyState
                                        graphicName={`paintbrush`}
                                        graphicText={`Paint Brush and Canvas`}
                                        bodycopy={this.props.editPermitted ? <span>Create your first embed and start driving <strong>increased engagement</strong> with your visitors!</span> :
                                            <span>No Embeds have been created for your account yet.</span>}
                                        buttonName={this.props.editPermitted ? `letsstart` : null}
                                        buttonText={this.props.editPermitted ? `Let's Start` : null}
                                        buttonClick={this.props.editPermitted ? this.createNewEmbed : null}
                                    />
                                </Content>);

    handleSelectType = (types) => this.setState({contentTypes: types});

    handleSelectStatus = (status) => this.setState({embedState: status});

    handleActive = (status) => this.setState({active: status}, this.applyFilters);

    selectLabel = (labels) => this.setState({ labels })

    handleDateSelect = dateRange => this.setState({ dateRange });

    customDateSelect = dateRange => this.setState({ dateRange }, this.applyFilters);

    _renderPagination = () => {
        if(this.props.totalRows > this.itemsPerPage){
            return (
                <StandardPagination
                    currentIndex={this.props.currentPage * this.itemsPerPage}
                    itemsPerPage={this.itemsPerPage}
                    totalItems={this.props.totalRows}
                    firstLastButtons={false}
                    handlePrevious={this.handlePagination}
                    handleNext={this.handlePagination} />
            )
        }
    };

    handlePagination = direction => {
        if(direction === 'previous'){
            return this.applyFilters(this.props.currentPage - 1);
        }
        return this.applyFilters(this.props.currentPage + 1);
    };

    render() {
        return(
            <Page name={`library`} klass={this.props.classes.library}>
                {!this.props.isDataReceived && this.props.fetchingEmbeds ? this._renderLoadScreen() :
                    (this.props.isDataReceived && this.props.totalEmbeds === 0) ? this._renderEmptyState() :
                    <Content>
                        <div className={`libraryelement library-controls`}>
                            <ControlBar
                                searchPlaceholder={`Search by Name or URL`}
                                searchOnChange={this.handleSearch}
                                handleSelectType={this.handleSelectType}
                                handleSelectStatus={this.handleSelectStatus}
                                handleActive={this.handleActive}
                                active={this.state.active}
                                updateDateRange={this.handleDateSelect}
                                customRangeClick={this.customDateSelect}
                                dateRange={this.state.dateRange}
                                labels={this.props.labels}
                                selectedLabels={this.state.labels}
                                selectLabel={this.selectLabel}
                                applyFilters={this.applyFilters}
                                updateLabel={this.props.updateLabel}
                                deleteLabel={this.props.deleteLabel}
                                accountUUID={this.props.accountUUID}
                            />
                        </div>
                        <div className={`libraryelement library-content`}>
                            <Title size={`small`} name={`numberof`}>
                                <h3>
                                    <span className={`total`}>
                                        {`Total ${this.state.active ? 'Live' : 'Archived'} Embeds`}({this.props.totalRows})
                                    </span>
                                </h3>
                            </Title>
                            {this.props.fetchingEmbeds ? <Loader/> :
                                <div className={`embeds`}>
                                    {this.props.editPermitted ? this._renderCreateEmbedCard() : null}
                                    {this._renderEmbeds()}
                                </div>}
                            {this._renderPagination()}
                        </div>
                    </Content>
                }
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(LibraryPage);
